import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=21f21ce4&scoped=true&"
import script from "./language-switcher.js?vue&type=script&lang=js&"
export * from "./language-switcher.js?vue&type=script&lang=js&"
import style0 from "./language-switcher.scss?vue&type=style&index=0&id=21f21ce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f21ce4",
  null
  
)

export default component.exports